
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M18.802 12.819a1.783 1.783 0 000-1.639s0-.002-.002-.003c-.454-.882-2.939-4.178-6.8-4.178s-6.346 3.296-6.798 4.175a1.787 1.787 0 00-.002 1.647c.454.883 2.938 4.178 6.8 4.178s6.346-3.296 6.802-4.181zM12 15c-2.688 0-4.558-2.322-4.969-3 .406-.671 2.277-3 4.969-3s4.562 2.327 4.969 3c-.407.673-2.28 3-4.969 3zm2-3a2 2 0 11-3.999.001A2 2 0 0114 12zM.293 1.707A.999.999 0 111.707.293L5 3.586V2a1 1 0 112 0v2.49a2.504 2.504 0 01-2.49 2.5L2.004 7H2a1 1 0 01-.004-2l1.584-.006L.293 1.707zM17.01 4.51L17 2.004A1 1 0 0117.996 1H18a1 1 0 011 .996l.006 1.584L22.293.293a.999.999 0 111.414 1.414L20.414 5H22a1 1 0 110 2h-2.49a2.504 2.504 0 01-2.5-2.49zM7 19.51V22a1 1 0 11-2 0v-1.586l-3.293 3.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414l3.287-3.287L1.996 19A1 1 0 012 17h.004l2.506.01A2.504 2.504 0 017 19.51zm16.707 2.783a.999.999 0 11-1.414 1.414l-3.287-3.287L19 22.004A1 1 0 0118 23h-.004A1 1 0 0117 21.996l.01-2.506a2.504 2.504 0 012.5-2.49H22a1 1 0 110 2h-1.586l3.293 3.293z"}})])
          )
        }
      }
    